import { Grid } from '@mui/material'
import { memo, ReactNode } from 'react'

function DewiCardGrid({ children }: { children: ReactNode }) {
  return (
    <Grid
      container
      columnGap={2}
      rowGap={2}
      height="fit-content"
      justifyContent="center"
      sx={{ flex: '1' }}
    >
      {children}
    </Grid>
  )
}

export default memo(DewiCardGrid)
